import React from 'react';
import './customer-skeleton.scss';
import { Skeleton } from '@mui/material';

interface CustomerSkeleton {
  count?: number;
  className?: string;
}

export const CustomerSkeleton: React.FC<CustomerSkeleton> = ({
  count = 10,
  className = '',
}) => {
  return (
    <div className={`customer-list-skeleton ${className}`}>
      {Array.from({ length: count }).map((_, index) => (
        <div key={index} className="customer-list-skeleton__row">
          <Skeleton variant="circular" width={45} height={45} />

          <div className="customer-list-skeleton__text">
            <Skeleton variant="text" width="60%" height={20} />
            <Skeleton variant="text" width="40%" height={16} />
          </div>
        </div>
      ))}
    </div>
  );
};
